import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import track from '@src/utils/sensor/track';
import { realTimeModeOnTrendsSelector } from '@store/common/selectors';
import { isMetricFilterAppliedSelector } from '@store/trends/base/selectors';

interface ExportLinkProps {
  context: string;
  clickCallback: (context: string) => void;
  className?: string;
  trackEvent?: object;
  disabled?: boolean;
}

const StyledExportLink = styled.button`
  border: none;
  background-color: transparent;
  padding: 0;
  text-align: left;
  cursor: pointer;

  &:disabled {
    color: rgb(104 104 104 / 40%);
    font-style: italic;
    font-weight: 400;
  }

  width: 100% !important;
`;

const ExportLink: React.FC<ExportLinkProps> = ({
  clickCallback,
  context,
  className = '',
  disabled = false,
  trackEvent,
}) => {
  const clickHandler = useCallback(() => {
    clickCallback(context);
    if (trackEvent) {
      track(trackEvent);
    }
  }, [clickCallback, context]);

  const liveModeSelected = useSelector(realTimeModeOnTrendsSelector);
  const isMetricFilterApplied = useSelector(isMetricFilterAppliedSelector);

  return (
    <>
      <StyledExportLink
        type="button"
        onClick={clickHandler}
        className={className}
        disabled={disabled || liveModeSelected || isMetricFilterApplied}
      >
        <span>Export</span>
      </StyledExportLink>
    </>
  );
};

export default ExportLink;
